
export const FEATURE_FLAGS = {
    ENABLE_PAYMENTS: false, // Set to true once gateway is integrated
    ENABLE_AUTH: true,     // Set to true for cash games and profiles
    APP_COMING_SOON: true,
    CASH_GAMES_COMING_SOON: true
};
